/* Fixel · búsqueda de reparaciones compartida.
   - FxRepairSearch.norm / key / matches / rank: misma lógica que el finder de
     /pages/reparaciones (sin tildes ni mayúsculas; frase completa o todas las palabras).
   - Widget [data-fx-rsearch] (sección fx-repair-search): combobox accesible. */
(function () {
  if (window.FxRepairSearch) return;

  function norm(str) {
    return String(str || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  }
  function words(q) { q = norm(q); return q ? q.split(/\s+/) : []; }
  function matches(key, q) {
    var nq = norm(q);
    if (!nq) return true;
    if (key.indexOf(nq) !== -1) return true;
    return words(nq).every(function (w) { return key.indexOf(w) !== -1; });
  }
  /* Orden: empieza por la búsqueda > la contiene > todas las palabras; luego nombre más corto. */
  function rank(list, q, nameOf) {
    var nq = norm(q);
    return list.map(function (m, i) {
      var n = norm(nameOf(m)), s = n.indexOf(nq) === 0 ? 0 : (n.indexOf(nq) !== -1 ? 1 : 2);
      return { m: m, s: s, l: n.length, i: i };
    }).sort(function (a, b) { return a.s - b.s || a.l - b.l || a.i - b.i; }).map(function (x) { return x.m; });
  }
  function esc(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  window.FxRepairSearch = { norm: norm, matches: matches, rank: rank, esc: esc };

  /* ---------- Widget de la Home ---------- */
  function init(root) {
    if (root.__fxrs) return; root.__fxrs = 1;
    var input = root.querySelector('[data-fxrs-input]'), list = root.querySelector('[data-fxrs-list]'),
        panel = root.querySelector('[data-fxrs-panel]'), clear = root.querySelector('[data-fxrs-clear]'),
        status = root.querySelector('[data-fxrs-status]'), form = root.querySelector('form'),
        foot = root.querySelector('[data-fxrs-foot]');
    var T = JSON.parse(root.querySelector('[data-fxrs-text]').textContent);
    var data = null, results = [], limit = T.max, active = -1;

    function load() {
      if (data) return data;
      var el = root.querySelector('[data-fxrs-data]');
      try { data = JSON.parse(el.textContent); } catch (e) { data = []; }
      data.forEach(function (m) { m.k = norm(m.n + ' ' + m.b); });
      return data;
    }
    function open(on) {
      panel.hidden = !on; input.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (!on) { active = -1; input.removeAttribute('aria-activedescendant'); }
    }
    function setActive(i) {
      var opts = list.querySelectorAll('[role="option"]');
      if (!opts.length) return;
      active = (i + opts.length) % opts.length;
      opts.forEach(function (o, j) { o.setAttribute('aria-selected', j === active ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', opts[active].id);
      opts[active].scrollIntoView({ block: 'nearest' });
    }
    function render() {
      var q = input.value;
      clear.hidden = !q;
      if (norm(q).length < T.min) { list.innerHTML = ''; status.textContent = ''; foot.hidden = true; open(false); return; }
      if (!data) { list.innerHTML = '<li class="fxrs__state">' + esc(T.loading) + '</li>'; open(true); }
      var all = load();
      results = rank(all.filter(function (m) { return matches(m.k, q); }), q, function (m) { return m.n; });
      var shown = results.slice(0, limit), id = root.id + '-opt-';
      var html = shown.map(function (m, i) {
        var img = m.i ? '<img src="' + esc(m.i) + '" alt="" width="48" height="48" loading="lazy" decoding="async">' : '<span class="fxrs__ph"></span>';
        return '<li role="option" id="' + id + i + '" aria-selected="false" class="fxrs__opt"><a href="' + esc(m.u) + '" tabindex="-1">' +
          '<span class="fxrs__img" aria-hidden="true">' + img + '</span>' +
          '<span class="fxrs__txt"><span class="fxrs__name">' + esc(m.n) + '</span><span class="fxrs__meta">' + esc(m.b) + '</span></span>' +
          '<span class="fxrs__go" aria-hidden="true">' + esc(T.cta) + '</span></a></li>';
      }).join('');
      if (!results.length) {
        html = '<li class="fxrs__state fxrs__state--empty"><strong>' + esc(T.emptyTitle.replace('{query}', q.trim())) + '</strong><span>' + esc(T.emptyBody) + '</span>' +
          (T.wa ? '<a class="fxrs__wa" href="' + esc(T.wa) + '" target="_blank" rel="noopener">' + esc(T.waLabel) + '</a>' : '') + '</li>';
      }
      foot.hidden = !(results.length > shown.length);
      list.innerHTML = html; active = -1; input.removeAttribute('aria-activedescendant');
      status.textContent = results.length ? T.count.replace('{n}', results.length) : T.emptyTitle.replace('{query}', q.trim());
      open(true);
    }

    var mq = window.matchMedia ? matchMedia('(max-width: 749px)') : null;
    function setPh() { input.setAttribute('placeholder', (mq && mq.matches ? input.getAttribute('data-ph-mobile') : input.getAttribute('data-ph')) || ''); }
    setPh(); if (mq) { if (mq.addEventListener) mq.addEventListener('change', setPh); else if (mq.addListener) mq.addListener(setPh); }

    input.addEventListener('focus', function () { load(); if (input.value) render(); });
    input.addEventListener('input', function () { limit = T.max; render(); });
    input.addEventListener('keydown', function (e) {
      var opts = list.querySelectorAll('[role="option"]');
      if (e.key === 'ArrowDown') { e.preventDefault(); if (panel.hidden) render(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Enter') {
        if (active >= 0 && opts[active]) { e.preventDefault(); window.location.href = opts[active].querySelector('a').href; }
        else if (results.length === 1) { e.preventDefault(); window.location.href = results[0].u; }
        else { e.preventDefault(); render(); }
      }
      else if (e.key === 'Escape') { if (!panel.hidden) { e.preventDefault(); open(false); } else { input.value = ''; render(); } }
    });
    clear.addEventListener('click', function () { input.value = ''; render(); input.focus(); });
    foot.addEventListener('click', function (e) {
      if (!e.target.closest('[data-fxrs-more]')) return;
      e.preventDefault();
      var prev = list.querySelectorAll('[role="option"]').length;
      limit += T.max; render(); input.focus();
      var first = list.querySelectorAll('[role="option"]')[prev]; if (first) first.scrollIntoView({ block: 'nearest' });
    });
    foot.addEventListener('mousedown', function (e) { e.preventDefault(); });
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); });
    document.addEventListener('click', function (e) { if (!e.target.isConnected || root.contains(e.target)) return; open(false); });
  }
  function boot() { document.querySelectorAll('[data-fx-rsearch]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
